(function(){
	"use strict";

	angular
		.module('pwc.directives')
		.directive('printSettings', printSettings);

	function printSettings(){
		return {
			template: '<md-input-container>' +
					  	'<label>Font Size</label>' +
					  	'<input ng-model="printSettings.fontSize" type="number" min="5">' +
					  '</md-input-container>',
			scope: {
				printSettings: '=scope'
			}
		};
	}

})();
